import React from 'react';

import './index.css';

function Wrapper({ className, children }) {
  return (
    <div
      className={`${
        className !== undefined ? className : ''
      } wrapper container-fluid`}
    >
      {children !== undefined ? children : ''}
    </div>
  );
}

export default Wrapper;
